import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AlocacaoPage } from '../pages/alocacao.page';
import { GradePage } from '../pages/grade.page';
import { ProfessorPage } from '../pages/professor.page';

const AlocacaoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/alocacao' element={<AlocacaoPage />} />
      <Route path='/alocacao/professor/:id_professor' element={<ProfessorPage />} />
      <Route path='/alocacao/grade' element={<GradePage />} />
    </Routes>
  );
};

export { AlocacaoRoutes };
